<!--page starts-->
<section class="page-wrapper">
	<!-- <div class="popup-match">
		<div class="popup-match-detail">
			<div class="popup-match-detail-inner live-box" *ngIf="livematcheList?.data?.length > 0">
				<div class="popup-match-live">
					<p>live</p>
				</div>
				<div class="popup-match-live-score">
					
						<div class="popup-match-live-score-box">
							<div class="match-live-score-box">
								<div class="match-live-image">
									<img [src]="livematchesList?.first_image" alt="Bitmap-one">
								</div>
							</div>
							<div class="match-live-vs">
								<h4>vs</h4>
							</div>
							<div class="match-live-score-box">
								<div class="match-live-image">
									<img [src]="livematchesList?.second_image" alt="Bitmap">
								</div>
							</div>
						</div>
					
				</div>
				<div class="popup-match-live-text-btn">
					<div class="popup-matchcenter-btn orange-btn">
						<a [routerLink]="['/livescore', livematchesList?.matchid]" *ngIf="livematchesList?.matchid">matchcentre</a>
					</div>
				</div>
			</div>
			<div class="popup-match-detail-inner upcoming-box" *ngIf="livematcheList?.data?.length == 0">
				<div class="fixture-results-upcoming-box">
					<div class="fixture-results-upcoming-top">
						 <div class="fixture-results-upcoming-ticket">
							 <a href="{{homeupcomingList?.redirect_url}}" target="_blank" *ngIf="homeupcomingList?.redirect_url"><img src="assets/images/ticket-logo.png" alt="ticket-logo"></a>
						 </div>
					</div>
					<div class="fixture-results-upcoming-bottom">
						 <div class="fixture-results-upcoming-match-team">
							 <div class="fixture-results-upcoming-team">
								 <div class="upcoming-team-box">
									 <img [src]="homeupcomingList?.first_image" alt="{{homeupcomingList?.first_name}}">
								 </div>
							 </div>
							 <div class="fixture-results-upcoming-vs">
								 <h4>VS</h4>
							 </div>
							 <div class="fixture-results-upcoming-team">
								 <img [src]="homeupcomingList?.second_image" alt="{{homeupcomingList?.second_name}}">
							 </div>
						 </div>
						 <div class="upcoming-match-all-detail">
							 <div class="upcoming-match-all-detail-box">
								 <p>Upcoming Match</p>
								 <h4>{{homeupcomingList?.date_time | amDateFormat: "DD MMM YYYY h:mm A z"}}</h4>
							 </div>
							 <div class="upcoming-match-all-detail-box">
								 <h4>{{homeupcomingList?.location}}</h4>
							 </div>
						 </div>
						 <div class="orange-btn">
							<a routerLink="/fixtures">view all</a>
						 </div>
					</div>
				 </div>
			</div>
		</div>
		<div class="popup-match-icon">
			<ul>
				<li class="bat-boll"><a href="javascript:void(0);"><img src="assets/images/bat-boll.png" alt="bat-boll"></a></li>
				<li class="close-popup"><a href="javascript:void(0);"><img src="assets/images/close-icon.png" alt="close-icon"></a></li>
			</ul>
		</div>
	</div> -->
	<div class="hero-slider-home-section margin-top-152 cf" *ngIf="bannerList?.data?.length > 0">
		<ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slidehomeConfig">
			<div ngxSlickItem class="hero-slider-home-box" *ngFor="let banner of bannerList?.data">
				<div class="hero-slider-home-box-banner" [ngStyle]="{'background-image':'url(' + banner?.file + ')'}" >
					<div class="hero-slider-home-box-banner-mobile"  [ngStyle]="{'background-image':'url(' + banner?.mobile_image + ')'}">
						<div class="container">
							<div class="hero-slider-home-detail" >
								<div class="hero-slider-home-inner">
									<h1 *ngIf="banner?.title">{{banner?.title}}</h1>
									<p *ngIf="banner?.subtitle">{{banner?.subtitle}}</p>
									<div class="hero-slider-home-btn" *ngIf="banner?.url">
										<a href="{{banner?.url}}" target="{{banner?.btn_type}}" *ngIf="banner?.btn_title">{{banner?.btn_title}}</a> 
									</div>
									<div class="hero-slider-home-btn two" *ngIf="banner?.button_url_2">
										<a href="{{banner?.button_url_2}}" target="{{banner?.btn_type}}" *ngIf="banner?.button_title_2">{{banner?.button_title_2}}</a> 
									</div>
								</div> 
							</div>
						</div>
					</div>
				</div>
			</div>
		</ngx-slick-carousel>
		<div class="hero-slider-home-social">
			<ul>
				
				<li>
				  <a href="{{settingList?.data?.facebook}}" target="_blank">
					<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
					  <circle cx="16.4407" cy="16.7642" r="15.8" stroke="#418940" stroke-width="0.4"/>
					  <path d="M17.774 17.8892H17.274V18.3892V24.2642H15.2264V18.3892V17.8892H14.7264H12.9407V15.8892H14.7264H15.2264V15.3892V13.2892C15.2264 12.2591 15.5548 11.5181 16.0643 11.0329C16.5776 10.544 17.3284 10.2642 18.2639 10.2642C18.9104 10.2642 19.5312 10.2959 19.9407 10.3256V11.8892H19.2978C18.4778 11.8892 17.8829 12.0832 17.5518 12.5672C17.3967 12.7939 17.332 13.0415 17.3023 13.2622C17.274 13.4726 17.274 13.6915 17.274 13.8743L17.274 13.8892V15.3892V15.8892H17.774H19.7978L19.2899 17.8892H17.774Z" fill="#418940" stroke="#418940"/>
					</svg> 
				  </a>
				</li>
				<li>
				  <a href="{{settingList?.data?.twitter}}" target="_blank">
					<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="16.5" cy="16.5" r="16.15" stroke="white" style="stroke:white;stroke-opacity:1;" stroke-width="0.7"/>
						<path d="M17.8255 15.4331L23.0124 9.5332H21.7832L17.2795 14.6559L13.6822 9.5332H9.5332L14.9729 17.2797L9.5332 23.4665H10.7625L15.5187 18.0568L19.3175 23.4665H23.4665L17.8251 15.4331H17.8255ZM16.1419 17.3478L15.5907 16.5765L11.2053 10.4387H13.0934L16.6323 15.3922L17.1834 16.1635L21.7837 22.6022H19.8959L16.1419 17.3482V17.3478Z" fill="white" style="fill:white;fill-opacity:1;"/>
						</svg>
						 
				  </a>
				</li>
				<li>
				  <a href="{{settingList?.data?.instagram}}" target="_blank">
					<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
					  <circle cx="16.4407" cy="16.7642" r="15.8" stroke="#418940" stroke-width="0.4"/>
					  <path d="M20.8461 10.5983L20.8445 10.5977C20.455 10.4463 20.0018 10.3384 19.3026 10.3056L20.8461 10.5983ZM20.8461 10.5983C21.2458 10.7521 21.5752 10.9556 21.9128 11.2926L21.9128 11.2926M20.8461 10.5983L21.9128 11.2926M21.9128 11.2926L21.9155 11.2953M21.9128 11.2926L21.9155 11.2953M21.9155 11.2953C22.2197 11.5943 22.455 11.956 22.6052 12.3552L22.6052 12.3552M21.9155 11.2953L22.6052 12.3552M22.6052 12.3552L22.607 12.3599M22.6052 12.3552L22.607 12.3599M22.607 12.3599C22.7579 12.7491 22.8663 13.2031 22.8992 13.9015M22.607 12.3599L22.8992 13.9015M22.6069 21.1686L22.6069 21.1686C22.758 20.7784 22.8664 20.3248 22.8992 19.6261L22.6069 21.1686ZM22.6069 21.1686L22.605 21.1737M22.6069 21.1686L22.605 21.1737M22.605 21.1737C22.4554 21.5727 22.2202 21.9342 21.916 22.2326L21.9159 22.2326M22.605 21.1737L21.9159 22.2326M21.9159 22.2326L21.9096 22.2389M21.9159 22.2326L21.9096 22.2389M21.9096 22.2389C21.6105 22.543 21.2487 22.7784 20.8495 22.9287L20.8495 22.9287M21.9096 22.2389L20.8495 22.9287M20.8495 22.9287L20.8449 22.9305M20.8495 22.9287L20.8449 22.9305M20.8449 22.9305C20.4557 23.0814 20.0017 23.1898 19.3033 23.2227M20.8449 22.9305L19.3033 23.2227M12.0362 22.9304L12.0362 22.9304C12.4264 23.0815 12.88 23.1899 13.5787 23.2227L12.0362 22.9304ZM12.0362 22.9304L12.0313 22.9285M12.0362 22.9304L12.0313 22.9285M12.0313 22.9285C11.6322 22.7788 11.2707 22.5435 10.9721 22.2393L10.9722 22.2393M12.0313 22.9285L10.9722 22.2393M10.9722 22.2393L10.9657 22.2329M10.9722 22.2393L10.9657 22.2329M10.9657 22.2329C10.6616 21.934 10.4263 21.5724 10.2762 21.1732L10.2762 21.1732M10.9657 22.2329L10.2762 21.1732M10.2762 21.1732L10.2741 21.1678M10.2762 21.1732L10.2741 21.1678M10.2741 21.1678C10.1229 20.7794 10.015 20.3257 9.98216 19.6268C9.94975 18.8918 9.94067 18.6624 9.94067 16.7642C9.94067 14.8641 9.94769 14.6363 9.98212 13.9022C10.0149 13.2024 10.1228 12.7498 10.2742 12.3603L10.2742 12.3603M10.2741 21.1678L10.2742 12.3603M10.2742 12.3603L10.2764 12.3546M10.2742 12.3603L10.2764 12.3546M10.2764 12.3546C10.4259 11.9556 10.6611 11.5941 10.9653 11.2958L10.9654 11.2958M10.2764 12.3546L10.9654 11.2958M10.9654 11.2958L10.972 11.2891M10.9654 11.2958L10.972 11.2891M10.972 11.2891C11.2708 10.9849 11.6323 10.7496 12.0315 10.5997L12.0315 10.5998M10.972 11.2891L12.0315 10.5998M12.0315 10.5998L12.0368 10.5977M12.0315 10.5998L12.0368 10.5977M12.0368 10.5977C12.4262 10.4463 12.8786 10.3385 13.578 10.3056C14.313 10.2732 14.5425 10.2642 16.4407 10.2642C18.3408 10.2642 18.5686 10.2712 19.3026 10.3056L12.0368 10.5977ZM22.8992 13.9015C22.9316 14.6365 22.9407 14.866 22.9407 16.7642C22.9407 18.6642 22.9337 18.892 22.8992 19.6261L22.8992 13.9015ZM19.3033 23.2227C18.5683 23.2551 18.3389 23.2642 16.4407 23.2642C14.5406 23.2642 14.3128 23.2571 13.5787 23.2227L19.3033 23.2227ZM16.4407 12.7642C15.3798 12.7642 14.3624 13.1856 13.6122 13.9357C12.8621 14.6859 12.4407 15.7033 12.4407 16.7642C12.4407 17.825 12.8621 18.8424 13.6122 19.5926C14.3624 20.3427 15.3798 20.7642 16.4407 20.7642C17.5015 20.7642 18.519 20.3427 19.2691 19.5926C20.0192 18.8424 20.4407 17.825 20.4407 16.7642C20.4407 15.9025 20.1627 15.0696 19.6563 14.3852C19.8025 14.437 19.9577 14.4642 20.1157 14.4642C20.4803 14.4642 20.8301 14.3193 21.0879 14.0614C21.3458 13.8036 21.4907 13.4538 21.4907 13.0892C21.4907 12.7245 21.3458 12.3748 21.0879 12.1169C20.8301 11.859 20.4803 11.7142 20.1157 11.7142C19.751 11.7142 19.4013 11.859 19.1434 12.1169C18.8855 12.3748 18.7407 12.7245 18.7407 13.0892C18.7407 13.2472 18.7679 13.4024 18.8197 13.5485C18.1353 13.0422 17.3023 12.7642 16.4407 12.7642ZM16.4407 15.1642C16.865 15.1642 17.272 15.3327 17.572 15.6328C17.8721 15.9328 18.0407 16.3398 18.0407 16.7642C18.0407 17.1885 17.8721 17.5955 17.572 17.8955C17.272 18.1956 16.865 18.3642 16.4407 18.3642C16.0163 18.3642 15.6094 18.1956 15.3093 17.8955C15.0092 17.5955 14.8407 17.1885 14.8407 16.7642C14.8407 16.3398 15.0092 15.9328 15.3093 15.6328C15.6094 15.3327 16.0163 15.1642 16.4407 15.1642Z" fill="#418940" stroke="#418940"/>
					</svg>  
				  </a>
				</li>
				<li>
				  <a href="{{settingList?.data?.tiktok}}" target="_blank">
					<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
					  <circle cx="16.4407" cy="16.7642" r="15.8" stroke="#418940" stroke-width="0.4"/>
					  <path d="M22.9407 13.8157V15.4009C21.9442 15.3129 20.986 14.9574 20.1683 14.3671L19.3756 13.7949V14.7725V20.0142C19.3756 22.366 17.4823 24.2642 15.1581 24.2642C12.9856 24.2642 10.9407 22.4939 10.9407 20.0142C10.9407 17.6084 12.9334 15.6963 15.3048 15.7736V17.3508C13.8068 17.2629 12.5108 18.4754 12.5108 20.0142C12.5108 21.4904 13.7131 22.6808 15.1664 22.6808H15.1665C15.8535 22.6807 16.5132 22.4126 17.0068 21.9338C17.5002 21.455 17.7891 20.803 17.8134 20.1151L17.8138 20.1063V20.0975V10.2642H19.4062C19.5051 11.0672 19.8411 11.8267 20.3767 12.4417C21.021 13.1888 21.7886 13.54 22.3888 13.7038C22.5947 13.76 22.7823 13.7946 22.9407 13.8157Z" fill="#418940" stroke="#418940"/>
					</svg>                  
				  </a>
				</li>
				<li>
				  <a href="{{settingList?.data?.youtube}}" target="_blank">
					<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
					  <circle cx="16.4407" cy="16.7642" r="15.8" stroke="#418940" stroke-width="0.4"/>
					  <g clip-path="url(#clip0_1421_17330)">
					  <path d="M16.4917 10.7632H16.5807C17.4027 10.7662 21.5677 10.7962 22.6907 11.0982C23.0302 11.1904 23.3395 11.37 23.5878 11.6192C23.8361 11.8684 24.0147 12.1784 24.1057 12.5182C24.2067 12.8982 24.2777 13.4012 24.3257 13.9202L24.3357 14.0242L24.3577 14.2842L24.3657 14.3882C24.4307 15.3022 24.4387 16.1582 24.4397 16.3452V16.4202C24.4387 16.6142 24.4297 17.5282 24.3577 18.4802L24.3497 18.5852L24.3407 18.6892C24.2907 19.2612 24.2167 19.8292 24.1057 20.2472C24.015 20.5871 23.8365 20.8973 23.5882 21.1465C23.3398 21.3957 23.0303 21.5753 22.6907 21.6672C21.5307 21.9792 17.1217 22.0012 16.5107 22.0022H16.3687C16.0597 22.0022 14.7817 21.9962 13.4417 21.9502L13.2717 21.9442L13.1847 21.9402L13.0137 21.9332L12.8427 21.9262C11.7327 21.8772 10.6757 21.7982 10.1887 21.6662C9.84916 21.5744 9.53974 21.395 9.2914 21.1459C9.04306 20.8969 8.86452 20.587 8.77367 20.2472C8.66267 19.8302 8.58867 19.2612 8.53867 18.6892L8.53067 18.5842L8.52267 18.4802C8.47332 17.8026 8.44597 17.1236 8.44067 16.4442L8.44067 16.3212C8.44267 16.1062 8.45067 15.3632 8.50467 14.5432L8.51167 14.4402L8.51467 14.3882L8.52267 14.2842L8.54467 14.0242L8.55467 13.9202C8.60267 13.4012 8.67367 12.8972 8.77467 12.5182C8.86537 12.1782 9.04384 11.8681 9.29219 11.6189C9.54054 11.3696 9.85004 11.1901 10.1897 11.0982C10.6767 10.9682 11.7337 10.8882 12.8437 10.8382L13.0137 10.8312L13.1857 10.8252L13.2717 10.8222L13.4427 10.8152C14.3944 10.7846 15.3465 10.7676 16.2987 10.7642H16.4917V10.7632ZM14.8407 13.9732V18.7912L18.9977 16.3832L14.8407 13.9732Z" fill="#418940"/>
					  </g>
					  <defs>
					  <clipPath id="clip0_1421_17330">
					  <rect width="16" height="16" fill="white" transform="translate(8.44067 8.76416)"/>
					  </clipPath>
					  </defs>
					</svg>                  
				  </a>
				</li>
				<li>
				  <a href="{{settingList?.data?.linkedin}}" target="_blank">
					<svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
					  <circle cx="16.4407" cy="16.7642" r="15.8" stroke="#418940" stroke-width="0.4"/>
					  <path d="M12.5408 11.5494V11.5492C12.5408 11.2094 12.4049 10.8835 12.1618 10.6423C11.9175 10.4006 11.5862 10.2642 11.2404 10.2642H11.2402C10.8954 10.264 10.5645 10.4 10.3195 10.6424L12.5408 11.5494ZM12.5408 11.5494C12.5408 11.7178 12.5074 11.8846 12.4425 12.04C12.3776 12.1954 12.2824 12.3364 12.1625 12.4547L12.1625 12.4547M12.5408 11.5494L12.1625 12.4547M12.1625 12.4547L12.1612 12.4559M12.1625 12.4547L12.1612 12.4559M12.1612 12.4559C11.9167 12.699 11.5857 12.835 11.2409 12.8342L11.24 12.8342M12.1612 12.4559L11.24 12.8342M11.24 12.8342C10.8952 12.8339 10.5644 12.6981 10.319 12.456M11.24 12.8342L10.319 12.456M10.319 12.456C10.1994 12.3371 10.1045 12.1958 10.0396 12.0402C9.97463 11.8845 9.94102 11.7175 9.94067 11.5487C9.94079 11.2086 10.0763 10.8831 10.3195 10.6425L10.319 12.456ZM15.141 15.1425H16.7408V15.9375L17.6875 16.1621C17.9622 15.6158 18.729 15.0235 20.0184 15.0235C21.3145 15.0235 21.9807 15.367 22.3604 15.8963C22.7714 16.4691 22.9407 17.378 22.9407 18.7263V23.2642H21.1407V19.3458C21.1407 18.549 21.0475 17.8448 20.7785 17.3241C20.6396 17.055 20.4475 16.8228 20.1881 16.6602C19.9275 16.4967 19.6301 16.4231 19.3128 16.4231C18.5177 16.4231 17.8865 16.7154 17.4752 17.2868C17.0848 17.8291 16.941 18.557 16.941 19.3451V23.2642H15.141V15.1425ZM12.1397 15.0235V23.1452H10.3397V15.0235H12.1397Z" fill="#418940" stroke="#418940"/>
					</svg>                  
				  </a>
				</li>
			  </ul>  
		</div>
	</div>
	<div class="advertise-home-section cf" *ngIf="adbannerList?.data?.length > 0">
		<ul>
			<ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slideadvertiseConfig">
				<li ngxSlickItem *ngFor="let banner of adbannerList?.data">
					<a href="{{banner?.url}}" target="{{banner?.btn_type}}" ><img [src]="banner?.file" alt="{{banner?.title}}"></a>
				</li>
			</ngx-slick-carousel>
		</ul>
	</div>
	<div class="latest-new-section margin-top-90 cf">
		<div class="container-full">
			<div class="latest-new-main">
				<div class="comman-title">
					<div class="comman-title-inner">
						<div class="comman-title-left">
							<h3>Latest News</h3>
						</div>
						<div class="comman-btn">
							<a routerLink="/news">View more</a>
						</div>
					</div>
				</div>
				<div class="latest-new-detail margin-top-30">
					<div class="latest-new-left" *ngIf="homenewsList?.data?.is_features?.length > 0">
						<div class="latest-new-left-box" [ngStyle]="{'background-image':'url(' + homenewsList?.data?.is_features[0]?.image + ')', 'background-repeat' : 'no-repeat'}">
							<div class="latest-new-left-content">
								<h3>{{homenewsList?.data?.is_features[0]?.title}}</h3>
								<p>{{homenewsList?.data?.is_features[0]?.description | truncate:[200]}}</p>
								<h5>{{homenewsList?.data?.is_features[0]?.date | amDateFormat: "DD MMMM YYYY"}}</h5>
								<div class="orange-btn">
									<a [routerLink]="['/news', homenewsList?.data?.is_features[0]?.slug]">Read more</a>
								</div>
							</div>
						</div>
					</div>
					<div class="latest-new-right" *ngIf="homenewsList?.data?.newsletter?.length > 0">
						<div class="latest-new-box" *ngFor="let news of homenewsList?.data?.newsletter">
							<a [routerLink]="['/news', news?.slug]">
								<div class="latest-new-box-image">
									<img [src]="news?.thumbnail_image" alt="{{news?.title}}">
								</div>
								<div class="latest-new-box-content">
									<h3>{{news?.title}}</h3>
									<p>{{news?.description | truncate:[120]}}</p>
									<h5>{{news?.date | amDateFormat: "DD MMMM YYYY"}}</h5>
								</div>
							</a>
						</div>
					</div>
				</div>
				<div class="mobile-btn-section">
					<div class="comman-btn">
						<a routerLink="/news">View more</a>
					</div>
				</div>
			</div> 
		</div>
	</div>
	<div class="video-home-slider-section margin-top-90 cf" *ngIf="videoList?.data?.length > 0">
		<div class="container-full">
			<div class="video-home-slider-detail">
				<div class="video-home-slider-left">
					<div class="video-home-foxtv-logo">
						<img src="assets/images/foxestv-logo-new.png" alt="foxestv-logo">
					</div>
					<div class="orange-btn">
						<a routerLink="/videos">View more</a>
					</div>
				</div>
				<div class="video-home-slider-right">
					<div class="video-home-slider-right-inner">
						<ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slidevideoConfig">
							<div ngxSlickItem class="video-home-slider-box" *ngFor="let video of videoList?.data| slice:0:6; let i = index ">
								<div class="video-home-slider-box-inner"  [ngStyle]="{'background-image':'url(' + video?.image + ')', 'background-repeat' : 'no-repeat'}">
									<div class="video-home-slider-overlay">
										<div class="video-overlay-play-icon">
											<a href="{{video?.video}}" class="popup-youtube">
												<img src="assets/images/play-icon-new.svg" alt="play-icon">
											</a>
										</div>
										<div class="video-overlay-content">
											<p>{{video?.date | amDateFormat: "DD MMMM YYYY"}}</p>
											<h4>{{transformQuote (video?.title) }}</h4>
										</div>
									</div>
								</div>
							</div>
						</ngx-slick-carousel>
					</div>
				</div>
				
			</div>
		</div>
	</div>
	<div class="fixture-results-section margin-top-90 cf">
		<div class="container-full">
			<div class="fixture-results-main">
				<div class="comman-title">
					<div class="comman-title-inner">
						<div class="comman-title-left">
							<h3>FIXTURES AND RESULTS</h3>
						</div>
						<div class="comman-btn">
							<a routerLink="/fixtures">View more</a>
						</div>
					</div>
				</div>
				<div class="fixture-results-detail margin-top-30">
                    <div class="fixture-results-left" *ngIf="homeupcomingList">
					    <div class="fixture-results-upcoming-box" style="background-image:url(assets/images/new-fixture-result-bg.jpeg); background-repeat: no-repeat; ">
						   <div class="fixture-results-upcoming-top">
								<div class="fixture-results-upcoming-ticket">
									<a href="{{homeupcomingList?.redirect_url}}" target="_blank" *ngIf="homeupcomingList?.redirect_url"><img src="assets/images/ticket-logo.png" alt="ticket-logo"></a>
								</div>
						   </div>
						   <div class="fixture-results-upcoming-bottom">
							    <div class="fixture-results-upcoming-match-team">
								    <div class="fixture-results-upcoming-team">
										<div class="upcoming-team-box">
                                            <img [src]="homeupcomingList?.first_image" alt="{{homeupcomingList?.first_name}}">
										</div>
								    </div>
								    <div class="fixture-results-upcoming-vs">
										<h4>VS</h4>
									</div>
								    <div class="fixture-results-upcoming-team">
										<img [src]="homeupcomingList?.second_image" alt="{{homeupcomingList?.second_name}}">
									</div>
							    </div>
								<div class="upcoming-match-all-detail">
									<div class="upcoming-match-all-detail-box">
										<p>Upcoming Match</p>
										<h4>{{homeupcomingList?.date_time | amDateFormat: "DD MMM YYYY h:mm A z"}}</h4>
									</div>
									<div class="upcoming-match-all-detail-box">
										<h4>{{homeupcomingList?.location}}</h4>
									</div>
								</div>
						   </div>
					    </div>
				    </div>
				   <div class="fixture-results-right" *ngIf="homepastList">
					    <div class="fixture-results-right-box" style="background-image:url(assets/images/fixture-complete-bg.png); background-repeat: no-repeat; ">
							<div class="fixture-results-match-complete">
								<div class="fixture-results-match-complete-box">
									<div class="match-complete-team won">
										<h3>{{homepastList?.result}}</h3>
									</div>
									<div class="match-complete-team">
									</div>
								</div>
								<div class="repot-icon" *ngIf="homepastList?.day_1_url != ''">
									<a href="{{homepastList?.day_1_url}}" *ngIf="homepastList?.day_1_url != ''"><img src="assets/images/report.png" alt="report-logo"></a>
									<a href="{{homepastList?.day_2_url}}" *ngIf="homepastList?.day_2_url != ''"><img src="assets/images/report.png" alt="report-logo"></a>
									<a href="{{homepastList?.day_3_url}}" *ngIf="homepastList?.day_3_url != ''"><img src="assets/images/report.png" alt="report-logo"></a>
									<a href="{{homepastList?.day_4_url}}" *ngIf="homepastList?.day_4_url != ''"><img src="assets/images/report.png" alt="report-logo"></a>
								</div>
							</div>
							<div class="fixture-results-upcoming-bottom">
								<div class="fixture-results-upcoming-match-team">
									<div class="fixture-results-upcoming-team">
										<div class="upcoming-team-box">
											<img [src]="homepastList?.first_image" alt="{{homepastList?.first_name}}">
										</div>
									</div>
									<div class="fixture-results-upcoming-vs">
										<h4>VS</h4>
									</div>
									<div class="fixture-results-upcoming-team">
										<img [src]="homepastList?.second_image" alt="{{homepastList?.second_name}}">
									</div>
								</div>
								<div class="upcoming-match-all-detail">
									<div class="upcoming-match-all-detail-box">
										<p>Recent Match</p>
										<h4>{{homepastList?.date_time | amDateFormat: "DD MMM YYYY h:mm A z"}}</h4>
									</div>
									<div class="upcoming-match-all-detail-box">
										<h4>{{homepastList?.location}}</h4>
									</div>
								</div>
						    </div>
						</div>
				   </div>
				</div>
				<div class="mobile-btn-section">
					<div class="comman-btn">
						<a routerLink="/fixtures">View more</a>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="player-home-section margin-top-90 cf">
		<div class="player-home-top margin-top-50">
			<div class="container-full">
				<div class="comman-title">
					<div class="comman-title-inner">
						<div class="comman-title-left">
							<h3>SQUAD</h3>
						</div>
						<div class="comman-btn orange-btn">
							<select class="player-name">
								<option value="team1" >First Team</option>
								<option value="team2" >Women's TEAM</option>
								<!-- <option value="team3" >Academy</option> -->
								<option value="team4" >Coaching Staff</option>
							</select>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="player-home-bottom">
			<div class="player-home-inner player-main-content active" *ngIf="playerManList?.data?.length > 0" id="team1">
				<ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slideplayerConfig">
					<div ngxSlickItem class="player-box" *ngFor="let man of playerManList?.data; let i = index">
						<div class="player-image">
							<img [src]="man?.image"  alt="{{man?.first_name}}">  
							<div class="player-number">
								<h4>{{man?.players_number}}</h4>
							</div>                                     
						</div>
						<div class="player-content">
							<div class="player-name">
								<a  [routerLink]="['/player-single', man?.slug]" tabindex="0">
									{{man?.first_name}} <strong>{{man?.last_name}} </strong>                
								</a>
							</div>
							<div class="player-birth-date-type">
								<div class="player-type">
									<p>{{man?.designation}}</p>
								</div>
								<div class="player-birth-date">
									<p class="celender-icon">{{man?.dob | amDateFormat: "DD MMMM YYYY"}}</p>
								</div>
							</div>
							<div class="player-sponsored">
								<a href="#" target="_blank">
								   <img [src]="man?.sponsor_image" alt="sponsor-img">  
								</a>
							</div>
							<!--<div class="player-all-detail">
								<div class="player-all-detail-box">
									<p>Matches</p>
									<h3>{{man?.players_stats[0]?.matches}}</h3>
								</div>
								<div class="player-all-detail-box">
									<p>Runs</p>
									<h3>{{man?.players_stats[0]?.total_runs}}</h3>
								</div>
								<div class="player-all-detail-box">
									<p>HS</p>
									<h3>{{man?.players_stats[0]?.highest_score}}</h3>
								</div>
							</div>-->
							<div class="get-jersey" *ngIf="man?.buy_the_jersey != ''">
								<div class="jersey-icon"><img src="assets/images/t-shirt.png" alt="jersey"></div>
								<a href="{{man?.buy_the_jersey}}" target="_blank"  >buy The Jersey</a>
							</div>
						</div>
					</div>
				</ngx-slick-carousel>
			</div>
			<div class="player-home-inner player-main-content active" *ngIf="playerWomenList?.data?.length > 0" id="team2">
				<ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slideplayerConfig">
					<div ngxSlickItem class="player-box" *ngFor="let women of playerWomenList?.data; let i = index">
						<div class="player-image">
							<img [src]="women?.image"  alt="{{women?.first_name}}">  
							<div class="player-number">
								<h4>{{women?.players_number}}</h4>
							</div>                                     
						</div>
						<div class="player-content">
							<div class="player-name">
								<a [routerLink]="['/player-single', women?.slug]" tabindex="0">
									{{women?.first_name}} <strong>{{women?.last_name}} </strong>                
								</a>
							</div>
							<div class="player-birth-date-type">
								<div class="player-type">
									<p>{{women?.designation}}</p>
								</div>
								<!-- <div class="player-birth-date">
									<p class="celender-icon">{{women?.dob | amDateFormat: "DD MMMM YYYY"}}</p>
								</div> -->
							</div>
							<div class="player-sponsored">
								<a href="#" target="_blank">
								   <img [src]="women?.sponsor_image" alt="sponsor-img">  
								</a>
							</div>
							<!-- <div class="player-all-detail">
								<div class="player-all-detail-box">
									<p>Matches</p>
									<h3>{{women?.players_stats[0]?.matches}}</h3>
								</div>
								<div class="player-all-detail-box">
									<p>Runs</p>
									<h3>{{women?.players_stats[0]?.total_runs}}</h3>
								</div>
								<div class="player-all-detail-box">
									<p>HS</p>
									<h3>{{women?.players_stats[0]?.highest_score}}</h3>
								</div>
							</div> -->
							<div class="get-jersey" *ngIf="women?.buy_the_jersey != ''">
								<div class="jersey-icon"><img src="assets/images/t-shirt.png" alt="jersey"></div>
								<a href="{{women?.buy_the_jersey}}" target="_blank"  >buy The Jersey</a>
							</div>
						</div>
					</div>
				</ngx-slick-carousel>
			</div>
			<!-- <div class="player-home-inner player-main-content" *ngIf="playerAcademyList?.data?.length > 0" id="team3">
				<ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slideplayerConfig">
					<div ngxSlickItem class="player-box" *ngFor="let academy of playerAcademyList?.data | slice: 0:6; let i = index">
						<div class="player-image">
							<img [src]="academy?.image"  alt="{{academy?.first_name}}">  
							<div class="player-number">
								<h4>{{academy?.players_number}}</h4>
							</div>                                     
						</div>
						<div class="player-content">
							<div class="player-name">
								<a href="#" tabindex="0">
									{{academy?.first_name}} <strong>{{academy?.last_name}} </strong>                
								</a>
							</div>
							<div class="player-birth-date-type">
								<div class="player-type">
									<p>{{academy?.designation}}</p>
								</div>
								<div class="player-birth-date">
									<p class="celender-icon">{{academy?.dob | amDateFormat: "DD MMMM YYYY"}}</p>
								</div>
							</div>
							<div class="player-sponsored">
								<a href="#" target="_blank">
								   <img [src]="academy?.sponsor_image" alt="sponsor-img">  
								</a>
							</div>
							<div class="player-all-detail">
							</div>
							<div class="get-jersey" *ngIf="academy?.buy_the_jersey != ''">
								<div class="jersey-icon"><img src="assets/images/t-shirt.png" alt="jersey"></div>
								<a href="{{academy?.buy_the_jersey}}" target="_blank"  >buy The Jersey</a>
							</div>
						</div>
					</div>
				</ngx-slick-carousel>
			</div> -->
			<div class="player-home-inner player-main-content" *ngIf="playerCoachingList?.data?.length > 0" id="team4">
				<ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slideplayerConfig">
					<div ngxSlickItem class="player-box" *ngFor="let coaching of playerCoachingList?.data; let i = index">
						<div class="player-image">
							<img [src]="coaching?.image"  alt="{{coaching?.first_name}}">  
							<div class="player-number">
								<h4>{{coaching?.players_number}}</h4>
							</div>                                     
						</div>
						<div class="player-content">
							<div class="player-name">
								<a [routerLink]="['/player-single', coaching?.slug]" tabindex="0">
									{{coaching?.first_name}} <strong>{{coaching?.last_name}} </strong>                
								</a>
							</div>
							<div class="player-birth-date-type">
								<div class="player-type">
									<p>{{coaching?.designation}}</p>
								</div>
								<div class="player-birth-date">
									<p class="celender-icon">{{coaching?.dob | amDateFormat: "DD MMMM YYYY"}}</p>
								</div>
							</div>
							<div class="player-sponsored">
								<a href="#" target="_blank">
								   <img [src]="coaching?.sponsor_image" alt="sponsor-img">  
								</a>
							</div>
							<div class="player-all-detail">
							</div>
							<div class="get-jersey" *ngIf="coaching?.buy_the_jersey != ''">
								<div class="jersey-icon"><img src="assets/images/t-shirt.png" alt="jersey"></div>
								<a href="{{coaching?.buy_the_jersey}}" target="_blank"  >buy The Jersey</a>
							</div>
						</div>
					</div>
				</ngx-slick-carousel>
			</div>
		</div>
	</div>
	<div class="social-wall-section margin-top-90 cf">
		<div class="social-wall-main">
			<div class="container-full">
				<div class="comman-title">
					<div class="comman-title-inner">
						<div class="comman-title-left">
							<h3>social wall</h3>
						</div>
					</div>
				</div>
				<div class="social-wall-tab-list">
					<ul>
						<li class="social-name active" id="social-tab1"><svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M25 0C11.1942 0 0 11.1942 0 25C0 38.8058 11.1942 50 25 50C38.8058 50 50 38.8058 50 25C50 11.1942 38.8058 0 25 0Z" fill="#C9C9C9" />
							<path d="M24.9986 21.3831C23.0077 21.3831 21.3829 23.0078 21.3829 24.9988C21.3829 26.9897 23.0077 28.6145 24.9986 28.6145C26.9896 28.6145 28.6144 26.9897 28.6144 24.9988C28.6144 23.0078 26.9896 21.3831 24.9986 21.3831ZM35.8431 24.9988C35.8431 23.5015 35.8567 22.0178 35.7726 20.5232C35.6885 18.7872 35.2925 17.2466 34.023 15.9771C32.7509 14.705 31.2129 14.3117 29.4769 14.2276C27.9796 14.1435 26.4959 14.1571 25.0014 14.1571C23.5041 14.1571 22.0204 14.1435 20.5258 14.2276C18.7898 14.3117 17.2491 14.7077 15.9797 15.9771C14.7075 17.2493 14.3142 18.7872 14.2301 20.5232C14.1461 22.0205 14.1596 23.5042 14.1596 24.9988C14.1596 26.4934 14.1461 27.9798 14.2301 29.4744C14.3142 31.2103 14.7103 32.751 15.9797 34.0205C17.2518 35.2926 18.7898 35.6859 20.5258 35.77C22.0231 35.8541 23.5068 35.8405 25.0014 35.8405C26.4986 35.8405 27.9824 35.8541 29.4769 35.77C31.2129 35.6859 32.7536 35.2899 34.023 34.0205C35.2952 32.7483 35.6885 31.2103 35.7726 29.4744C35.8594 27.9798 35.8431 26.4961 35.8431 24.9988ZM24.9986 30.5621C21.92 30.5621 19.4354 28.0774 19.4354 24.9988C19.4354 21.9201 21.92 19.4355 24.9986 19.4355C28.0773 19.4355 30.5619 21.9201 30.5619 24.9988C30.5619 28.0774 28.0773 30.5621 24.9986 30.5621ZM30.7898 20.5069C30.071 20.5069 29.4905 19.9265 29.4905 19.2077C29.4905 18.4889 30.071 17.9084 30.7898 17.9084C31.5086 17.9084 32.089 18.4889 32.089 19.2077C32.0893 19.3784 32.0558 19.5474 31.9906 19.7051C31.9254 19.8629 31.8297 20.0062 31.709 20.1269C31.5883 20.2476 31.445 20.3433 31.2872 20.4085C31.1295 20.4737 30.9604 20.5072 30.7898 20.5069Z" fill="white"/>
							</svg>
						</li>
					</ul>
				</div>
				<div class="social-wall-detail social-name-content active" id="social-tab1-content">
					<iframe src="https://widget.taggbox.com/129689" style="width:100%;height:600px;border:none;"></iframe>
				</div>
				
			</div>
		</div>
	</div>
    <div class="bg-image-bottom-title-btn-section margin-top-90 cf">
		<div class="bg-image-bottom-title-btn-detail" *ngIf="hometcardList?.data?.length > 0">
			<ngx-slick-carousel class="carousel" slickModal="slick-carousel" [config]="slideimagehoverConfig">
				<div ngxSlickItem class="bg-image-bottom-title-btn-box" *ngFor="let card of hometcardList?.data | slice: 0:4; let i = index">
					<div class="bg-image-bottom-title-btn-box-inner" [ngStyle]="{'background-image':'url(' + card?.image + ')', 'background-repeat' : 'no-repeat'}">
						<div class="bg-image-bottom-title-btn-overlay">
							<h3>{{card?.title}}</h3>
							<div class="orange-btn">
								<a href="{{card?.button_url}}">{{card?.button_name}}</a>
							</div>
						</div>
					</div>
				</div> 
			</ngx-slick-carousel>
		</div>
	</div>
	
</section><!-- page ends-->